import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { TextField } from '@material-ui/core';

const FormInputStyle = withStyles({
    root: {
        marginTop: '12px',
        marginBottom: '10px',
        '& .MuiFormLabel-root': {
            fontSize: '0.87rem',
        },
        '& label.Mui-focused': {
            color: '#019ee2',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#e1e1e3',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#e1e1e3',
            },
            '&:hover fieldset': {
                borderColor: '#019ee2',
            },
            '&.Mui-focused fieldset': {
                border: '1px solid #019ee2',
            },
        },
    },
})(TextField);

function FormInput(props) {
    const idName = name => `custom-input-${(name || '').toLowerCase().replace(/ /g, '-')}`;

    return (
        <FormInputStyle
            fullWidth
            margin="dense"
            label={props.label}
            defaultValue={props.defaultValue}
            value={props.value}
            id={idName(props.name)}
            onChange={props.onChange}
            variant={props.variant || 'outlined'}
            autoComplete={props.autoComplete ? "on" : "new-password"}
            {...props}
        >
            {props.children}
        </FormInputStyle>
    )
}

export default FormInput;

FormInput.propTypes = {
    name: PropTypes.string.isRequired,
}
